$mol_icon_send $mol_icon path \M2,21L23,12L2,3V10L17,12L2,14V21Z
